import { render } from "./HomeTab.vue?vue&type=template&id=5bb48624"
import script from "./HomeTab.vue?vue&type=script&lang=js"
export * from "./HomeTab.vue?vue&type=script&lang=js"

import "./HomeTab.vue?vue&type=style&index=0&id=5bb48624&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__